import { FC, Fragment } from 'react';

import Paper from '@mui/material/Paper';
import SidebarBox from 'components/SidebarBox';
import Skeleton from '@mui/material/Skeleton';
import Divider from '@mui/material/Divider';

type Props = {
  boxes?: number;
};

const SidebarSkeleton: FC<Props> = ({ boxes = 3 }) => (
  <Paper>
    {Array(boxes)
      .fill(0)
      .map((_, i) => (
        <Fragment key={i}>
          <SidebarBox label={<Skeleton width={100} />}>
            <Skeleton width={150} height="1.7em" />
          </SidebarBox>

          {i < boxes - 1 && <Divider />}
        </Fragment>
      ))}
  </Paper>
);

export default SidebarSkeleton;
